import FullScreenPage from "../../../components/FullScreenPage/FullScreenPage"
import UltimateBackground from "../../../components/UltimateBackground/UltimateBackground"
import UltimateSubfeaturesPopups from "../../../components/UltimateSubfeaturesPopups/UltimateSubfeaturesPopups"
import FeatureList from "../../../components/PromoComponents/UltimatePromoFeatureList/UltimatePromoFeatureList"
import Footer from "./Footer/Footer"
import Header from "./Header/Header"
import styles from "./PremiumToUltimatePaywall.module.scss"

const PremiumToUltimatePaywall = () => {
  return (
    <FullScreenPage containerClassName={styles.page}>
      <div className={styles.container}>
        <Header />
        <FeatureList />
        <Footer />
      </div>
      <UltimateBackground forceVisible />
    </FullScreenPage>
  )
}

export default PremiumToUltimatePaywall
